import { Ref } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';
import { AxiosError, AxiosResponse } from 'axios';

import { CommonResType } from '@/types/commonApiType';

import { api } from './_http';

// 구독 결제 - 결제가격
type GetSubscriptionGoodsParams = {
	member_group_pk?: string | number | null;
	special?: string | number | null;
};
type GetSubscriptionGoodsType = {
	member_group_pk: number;
	subscription_goods_name: string;
	subscription_goods_pk: number;
	subscription_goods_price: string;
	subscription_goods_sale_price: string;
	subscription_goods_sale_yn: string;
	subscription_goods_special_yn: string;
};
type GetSubscriptionGoodsResType = {
	subscription_goods: GetSubscriptionGoodsType[];
};
export const useGetSubscriptionGoodsDataApi = (params: Ref<GetSubscriptionGoodsParams>) => {
	const url = '/v1/front/getSubscriptionGoodsData';
	return useQuery<AxiosResponse, AxiosError, GetSubscriptionGoodsResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params.value),
		select: (res) => res.data?.data,
	});
};

// 구독 결제 - 프로모션 코드
type GetPromotionDataResType = {
	promotion_count: number;
};
export const useGetPromotionDataApi = () => {
	const url = '/v1/front/getPromotionData';
	return useQuery<AxiosResponse, AxiosError, GetPromotionDataResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};

// 구독 결제 - 프로모션 코드 확인
type CheckPromotionCodeDataType = {
	promotion_no: string;
	group_pk: number | null | undefined;
};

type CheckPromotionCodeResType = CommonResType<
	{
		promotion_type: string;
		promotion_sale_benefit: string;
		promotion_group_target: string;
	}[]
>;

export const useCheckPromotionCodeApi = () => {
	const url = '/v1/front/checkPromotionCode';
	return useMutation<AxiosResponse<CheckPromotionCodeResType>, AxiosError, CheckPromotionCodeDataType>({
		mutationFn: (data: CheckPromotionCodeDataType) => api.post(url, data),
	});
};

// 구독 결제 - 마스터 리스트
type master_list_nosub = {
	file_path: string;
	file_pk: number;
	master_exposure_seq: number;
	master_name: string;
	master_pk: number;
};
type master_list_onsub = {
	file_path: string;
	file_pk: number;
	master_exposure_seq: number;
	master_name: string;
	master_pk: number;
};
type GetMasterListResType = {
	master_list_nosub: master_list_nosub[];
	master_list_onsub: master_list_onsub[];
};
export const useGetMasterListDataApi = (appCall = true) => {
	const url = '/v1/front/getMasterList';
	return useQuery<AxiosResponse, AxiosError, GetMasterListResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
		enabled: appCall,
	});
};

export const useGetMasterListDataApi_enabled_false = () => {
	const url = '/v1/front/getMasterList';
	return useQuery<AxiosResponse, AxiosError, GetMasterListResType>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
		enabled: false,
	});
};
// 순서를 고려한 마스터 리스트 반환 함수
type MasterSubscribeListData = {
	master: MasterSubscribeListItem[];
};
export type MasterSubscribeListItem = {
	master_pk: number;
	master_exposure_seq: number;
	master_name: string;
	file_pk: number;
	file_path: string;
	sub: boolean;
};
export const useGetMasterSubscribeListApi = () => {
	const url = '/v1/front/getMasterSubscribeList';
	return useQuery<AxiosResponse, AxiosError, MasterSubscribeListData>({
		queryKey: [url],
		queryFn: () => api.get(url),
		select: (res) => res.data.data,
	});
};

// 구독 결제 - 결제요청
export type MakeSubscriptionDataType = {
	subscription_goods_pk: number;
	subscription_master_key: number[];
	pay_info_price: number;
	promotion_price?: number;
	promotion_code?: string;
	access_token: string;
	os?: string;
};
// type MakeSubscriptionResType = CommonResType;
// export const useMakeSubscriptionApi = () => {
// 	const url = '/v1/front/makeSubscription';
// 	return useMutation<AxiosResponse<MakeSubscriptionResType>, AxiosError, MakeSubscriptionDataType>({
// 		mutationFn: (data: MakeSubscriptionDataType) => api.post(url, data),
// 	});
// };
